import { useQuery } from "@apollo/client";
import type { Project } from "@casey/db-types";
import { GET_PROJECT_BY_ID } from "../gql";

interface ProjectResponse {
  project: Project | null;
}

interface ProjectVariables {
  id: string;
}

export function useProject(projectId?: string) {
  const { data, loading, error, refetch } = useQuery<
    ProjectResponse,
    ProjectVariables
  >(GET_PROJECT_BY_ID, {
    variables: { id: projectId || "" },
    skip: !projectId,
    errorPolicy: "all",
  });

  return {
    project: data?.project || null,
    loading,
    error,
    refetch,
  };
}
